export default "__VITE_ASSET__DYJrKdWg__"